export const appStateConstants = {
  IS_COMICS_VISIBLE: 'is_comics_visible',
  SETTINGS: 'settings',
  IS_USER_DATA_LOADING: 'is_user_data_loading',
  USER: 'user' ,
  IS_SETTING_DATA_LOADING: 'is_setting_data_loading'
}

export const contentSectionId = {
  preview: 'content_section_preview',
  one: 'content_section_one',
  two: 'content_section_two',
  three: 'content_section_three',
  four: 'content_section_four',
  last: 'content_section_last',
  stablecoin_explanation: 'content_section_stablecoin_explanation',
  protocol_explanation: 'content_section_protocol_explanation',
  memecoin_explanation: 'memecoin_explanation'
}

export const defaultConstants = {
  fadeTransitionDelay: 150,
  whitelistedStatus: 'whitelisted',
  delistedStatus: 'delisted',
}

export const comicsConstants = {
  type: {
    carousel: 'carousel',
    instagram: 'instagram',
  },
}

export function getFadeTransitionDelay(increment) {
  increment = increment || 1
  const fadeTransitionDelay = 150

  return (increment * fadeTransitionDelay) + 'ms'
}

export const cookieKeys = {
  is_wallet_connected: 'canceller_is_wallet_connected'
}

export const MAX_SEASON = 2
export const MAX_IMAGES_SEASON_1 = 27
export const MAX_IMAGES_SEASON_2 = 20
export const MAX_VIDEO_SEASON_1 = 19

export const storageKeys = {
  authToken: 'memefx_auth_token',
  is_phantom_wallet_connected: 'is_phantom_wallet_connected',
  wagmi: 'wagmi-vue',
  solana_wallet: 'solana_wallet'
}

export const wagmiConnectionStatus = {
  connecting: 'connecting',
  connected: 'connected',
  disconnected: 'disconnected'
}
